import format from './../../external/date-fns/esm/format/index.js';

function getColor(isSelectedStartOrEnd, isSelectedOrHoverRange, selectedFirstOrLastColor, selectedOrRangeHoverColor, normalColor) {
    if (isSelectedStartOrEnd) {
        return selectedFirstOrLastColor;
    }
    if (isSelectedOrHoverRange) {
        return selectedOrRangeHoverColor;
    }
    return normalColor;
}
function getMaxBookingDate(startDate, maxBookingDays) {
    if (startDate && maxBookingDays) {
        const maxBookingDate = new Date(startDate);
        maxBookingDate.setDate(maxBookingDate.getDate() + maxBookingDays);
        return maxBookingDate;
    }
    return undefined;
}
function formatDate(date, locale) {
    return (date && locale && format(date, 'dd/MM/yyyy', { locale })) || '';
}

export { formatDate, getColor, getMaxBookingDate };
